import { ILogger } from "./ILogger";
import { ISectionLogger } from "./ISectionLogger";
import { ISectionLoggerFactory } from "./ISectionLoggerFactory";
import { SectionLogger } from "./SectionLogger";
import { ILoggingSettings, LoggingSectionType } from "./types";

/**
 * Defaultní implementace {@link ISectionLoggerFactory}.
 * @includeToDoc
 */
export class SectionLoggerFactory implements ISectionLoggerFactory {
    private readonly _loggingSettings: ILoggingSettings;
    /**
     * Nevystačíme s "_logger", protože instance `SectionLoggerFactory` je naše defaultní, kdežto implementace {@link ILogger}
     * může být dodána custom - a to až poté, co je instance `SectionLoggerFactory` již vytvořena a zaregistrována v DIContaineru.
     *
     * Proto je potřeba `_loggerFactory`, který dynamicky vrátí správnou implementaci {@link ILogger}.
     */
    private readonly _loggerFactory: () => ILogger;

    constructor(loggingSettings: ILoggingSettings, loggerFactory: () => ILogger) {
        this._loggingSettings = loggingSettings;
        this._loggerFactory = loggerFactory;
    }

    public create(section: LoggingSectionType): ISectionLogger {
        const levelThreshold = this._loggingSettings.sections[section] || this._loggingSettings.defaultLevel;
        return new SectionLogger(section, levelThreshold, this._loggerFactory());
    }
}
